export class ValueResponse {
  currValue?: number;
  oldValue?: number;
}
